export const EVENT_TYPE_RANDEZ_VOUS = 'appointments'
export const EVENT_TYPE_VISIT_REPORT = 'visit-reports'

export const EVENT_RANDEZ_VOUS_RAPPEL = 'Rappel'
export const EVENT_VISIT_REPORT_APPEL = 'Appel'
